import { combineReducers } from 'redux'
import player from './player'
import filter from './filter'

export default combineReducers({
    player,
    filter
})